import { usePersonReadDataContext } from '@aibees/elephant/context';
import {
  useCompanyVisibilityState,
  useSearchTypeFromRoute,
} from '@aibees/elephant/hooks';
import { usePageType } from '@aibees/elephant/hooks/use-page-type';
import { SearchType } from '@aibees/elephant/types';
import { useMemo } from 'react';

export function useCompanyFieldDisabledState(searchType: SearchType) {
  const { isPeoplePage } = usePageType();
  const searchTypeFromRoute = useSearchTypeFromRoute();
  const { api: personApi } = usePersonReadDataContext();
  const { showNoDataAvailable } = useCompanyVisibilityState();

  const isViewingPeopleData = useMemo(
    () =>
      isPeoplePage ||
      searchTypeFromRoute === SearchType.People ||
      !!personApi?.data,
    [isPeoplePage, searchTypeFromRoute, personApi?.data]
  );

  const shouldDisable = useMemo(
    () =>
      isViewingPeopleData &&
      searchType === SearchType.Company &&
      showNoDataAvailable,
    [isViewingPeopleData, searchType, showNoDataAvailable]
  );

  return {
    isViewingPeopleData,
    shouldDisable,
  };
}
